var map = {
	"./breaking-down.jpg": 75023,
	"./child-development.jpg": 36436,
	"./childs-nutrition-and-digestion.jpg": 62239,
	"./complex-cases.jpg": 76983,
	"./kats-ambulance.jpg": 7487,
	"./mom-baby.jpg": 92483,
	"./pediatric-surgery.jpeg": 38032,
	"./pics/1.jpg": 96963,
	"./pics/10.jpg": 52133,
	"./pics/11.jpg": 85619,
	"./pics/12.jpg": 77553,
	"./pics/13.jpg": 34174,
	"./pics/14.jpg": 92225,
	"./pics/15.jpg": 55474,
	"./pics/16.jpg": 22831,
	"./pics/17.jpg": 30567,
	"./pics/18.jpg": 82917,
	"./pics/19.jpg": 92161,
	"./pics/1_old.jpg": 59312,
	"./pics/1st floor-ip-department-9.png": 14817,
	"./pics/2.jpg": 87607,
	"./pics/20.jpg": 12074,
	"./pics/21.jpg": 73978,
	"./pics/22.jpg": 13737,
	"./pics/23.jpg": 75380,
	"./pics/24.jpg": 53197,
	"./pics/25.jpg": 19,
	"./pics/26.jpg": 59471,
	"./pics/27.jpg": 18314,
	"./pics/28.jpg": 64174,
	"./pics/29.jpg": 20152,
	"./pics/2nd-floor-ip-department-10.png": 39601,
	"./pics/3.jpg": 28242,
	"./pics/30.jpg": 26689,
	"./pics/4.jpg": 99918,
	"./pics/5.jpg": 98204,
	"./pics/6.jpg": 15125,
	"./pics/7.jpg": 77495,
	"./pics/8.jpg": 84113,
	"./pics/9.jpg": 15828,
	"./pics/Baby Shop.jpg": 95923,
	"./pics/HDU.jpg": 2795,
	"./pics/InPatient Area.jpg": 62784,
	"./pics/InPatient Lobby.jpg": 64522,
	"./pics/LDU.jpg": 12235,
	"./pics/Main Lobby.jpg": 75087,
	"./pics/Neonatal Transport Incubator.jpg": 5210,
	"./pics/Operation Theatre.jpg": 31059,
	"./pics/Outpatient Department.jpg": 66422,
	"./pics/Private Room.jpg": 15154,
	"./pics/Radiology.jpg": 46793,
	"./pics/Reception.jpg": 12153,
	"./pics/SICU.jpg": 67368,
	"./pics/Semi Suit Room.jpg": 39130,
	"./pics/Suit Room.jpg": 17342,
	"./pics/baby-shop-4.png": 56190,
	"./pics/bangalore-old.jpg": 85635,
	"./pics/bangalore.jpg": 93043,
	"./pics/chili-pili-banner.jpg": 35173,
	"./pics/clinics-banner.jpg": 73475,
	"./pics/conference-room-bng-1.png": 73018,
	"./pics/dental.jpg": 99851,
	"./pics/dentistry-banner.webp": 78148,
	"./pics/diamond-12.png": 8676,
	"./pics/fertility-old.jpg": 2485,
	"./pics/fertility.jpg": 41383,
	"./pics/first-foot-imprint-ban.jpg": 27028,
	"./pics/first-foot-imprint-mys.jpg": 73800,
	"./pics/hospital-1.png": 47088,
	"./pics/hospital-bng.jpg": 9225,
	"./pics/kids-banner.png": 29371,
	"./pics/kids-web-banner.jpg": 38922,
	"./pics/main-lobby-2.png": 67224,
	"./pics/mysore-new/1st floor-OPdepartment.png": 34558,
	"./pics/mysore-new/Your paragraph text (13).jpg": 88257,
	"./pics/mysore-new/Your paragraph text (19).jpg": 96499,
	"./pics/mysore-new/Your paragraph text (5).jpg": 60608,
	"./pics/mysore-new/Your paragraph text.jpg": 64406,
	"./pics/mysore-new/aerobic-3391.jpg": 32887,
	"./pics/mysore-new/baby-shop-and-himalaya-3265.jpg": 51892,
	"./pics/mysore-new/cafeteria.png": 75470,
	"./pics/mysore-new/first-floor-ip-department-9590.jpg": 56698,
	"./pics/mysore-new/first-floor-op-department-3315.jpg": 80187,
	"./pics/mysore-new/hospital.png": 80520,
	"./pics/mysore-new/lab-9638.jpg": 74529,
	"./pics/mysore-new/library-9624.jpg": 21977,
	"./pics/mysore-new/main-lobby-3257.jpg": 4450,
	"./pics/mysore-new/nicu-in-born-3492.jpg": 81867,
	"./pics/mysore-new/nicu-outborn-3484.jpg": 35914,
	"./pics/mysore-new/obg-opd-3286.jpg": 37844,
	"./pics/mysore-new/obg-opd.png": 11255,
	"./pics/mysore-new/opd-9544.jpg": 27202,
	"./pics/mysore-new/pharmacy.png": 40882,
	"./pics/mysore-new/radiology-9559.jpg": 66258,
	"./pics/mysore-new/reception-3273.jpg": 59276,
	"./pics/mysore-new/reception.png": 53006,
	"./pics/mysore-new/second-floor-ip-department-9608.jpg": 43919,
	"./pics/mysore-new/sicu-3375.jpg": 97594,
	"./pics/mysore-new/triage-3414.jpg": 47395,
	"./pics/mysore-new/twin-sharing-3512.jpg": 53888,
	"./pics/mysore-new/yoga-room.png": 43358,
	"./pics/mysore.jpg": 93501,
	"./pics/nescafe.jpg": 19541,
	"./pics/nicu-21.png": 64717,
	"./pics/nicu.jpg": 92297,
	"./pics/obg-opd-7.png": 32566,
	"./pics/operation-theater-17.png": 33913,
	"./pics/paediatric-opd-8.png": 89402,
	"./pics/pharmacy-6.png": 51660,
	"./pics/photo-studio.jpg": 69093,
	"./pics/ramanagar-banner.jpg": 55916,
	"./pics/ramanagar-banner1.jpg": 20466,
	"./pics/ramanagara/inside-hospital.jpg": 76078,
	"./pics/ramanagara/lobby-1.jpg": 60150,
	"./pics/ramanagara/lobby-2.jpg": 15293,
	"./pics/ramanagara/main-entrance.jpg": 23188,
	"./pics/ramanagara/main-gate.jpg": 15115,
	"./pics/ramanagara/main-reception.jpg": 96979,
	"./pics/ramanagara/main_entrance.jpg": 76963,
	"./pics/ramanagara/main_gate.jpg": 6668,
	"./pics/ramanagara/new/IP-department.png": 20447,
	"./pics/ramanagara/new/NICU.png": 4107,
	"./pics/ramanagara/new/OBG-OPD.png": 739,
	"./pics/ramanagara/new/SICU-&-HDU.png": 64920,
	"./pics/ramanagara/new/aerobics-room.jpg": 67846,
	"./pics/ramanagara/new/baby-shop.jpg": 33265,
	"./pics/ramanagara/new/baby-shop.png": 63251,
	"./pics/ramanagara/new/cafeteria.jpg": 3687,
	"./pics/ramanagara/new/cafeteria.png": 63882,
	"./pics/ramanagara/new/conference-room.jpg": 46434,
	"./pics/ramanagara/new/doctors-lounge.jpg": 4256,
	"./pics/ramanagara/new/first-foot-imprint-ram.jpg": 17324,
	"./pics/ramanagara/new/first-imprints.jpg": 56977,
	"./pics/ramanagara/new/hospital.jpg": 11646,
	"./pics/ramanagara/new/hospital.png": 90889,
	"./pics/ramanagara/new/ip-biling.jpg": 62434,
	"./pics/ramanagara/new/laboratory.jpg": 47425,
	"./pics/ramanagara/new/main-lobby.jpg": 85514,
	"./pics/ramanagara/new/nicu.jpg": 20048,
	"./pics/ramanagara/new/nursing-station.jpg": 30945,
	"./pics/ramanagara/new/nursing-station.png": 9376,
	"./pics/ramanagara/new/obg-opd.jpg": 20860,
	"./pics/ramanagara/new/ot.jpg": 68342,
	"./pics/ramanagara/new/peadiatrics-opd.jpg": 61104,
	"./pics/ramanagara/new/pharmacy.jpg": 58642,
	"./pics/ramanagara/new/photo-studio-ram.jpg": 17995,
	"./pics/ramanagara/new/platinumroom.png": 35504,
	"./pics/ramanagara/new/private-room.jpg": 76093,
	"./pics/ramanagara/new/radiology.jpg": 30721,
	"./pics/ramanagara/new/radiology.png": 37169,
	"./pics/ramanagara/new/reception.jpg": 34350,
	"./pics/ramanagara/new/shared-room.jpg": 48909,
	"./pics/ramanagara/new/sicu.jpg": 50334,
	"./pics/ramanagara/new/studio.jpg": 30937,
	"./pics/ramanagara/new/suite-room.jpg": 88533,
	"./pics/ramanagara/new/triage.jpg": 45396,
	"./pics/ramanagara/new/triage.png": 94770,
	"./pics/ramanagara/our-journey.jpg": 56265,
	"./pics/ramanagara/reception.jpg": 33398,
	"./pics/ramanagara/ward-room.jpg": 81015,
	"./pics/ramanagara/ward.jpg": 59178,
	"./pics/ramnagar-1.jpg": 52318,
	"./pics/ramnagar-2.jpg": 42113,
	"./pics/ramnagar-3.jpg": 54823,
	"./pics/ramnagar-4.jpg": 24167,
	"./pics/ramnagar-5.jpg": 95094,
	"./pics/ramnagar-6.jpg": 44006,
	"./pics/ramnagar-7.jpg": 82362,
	"./pics/ramnagar-8.jpg": 65050,
	"./pics/ramnagar_banner.jpg": 40779,
	"./pics/reception-3.png": 47993,
	"./pics/triage-5.png": 64722,
	"./pics/tumakuru/Baby Shop.jpg": 10601,
	"./pics/tumakuru/Hospital.jpg": 47164,
	"./pics/tumakuru/Kids .jpg": 64662,
	"./pics/tumakuru/NICU.jpg": 90849,
	"./pics/tumakuru/Private.jpg": 56585,
	"./pics/tumakuru/Reception.jpg": 36683,
	"./pics/tumakuru/SICU.jpg": 8293,
	"./pics/tumakuru/Semi Suite.jpg": 62655,
	"./pics/tumakuru/Suite .jpg": 90966,
	"./pics/tumakuru/Tumakuru Cafeteria.jpg": 83325,
	"./pics/tumakuru/labour.jpg": 70241,
	"./pics/tumakuru/operation theater .jpg": 72904,
	"./pics/tumakuru/studio.JPEG": 8093,
	"./pics/tumakuru/twin-sharing..jpg": 85189,
	"./together-we-did.jpg": 3368,
	"./with-baby.jpg": 13998,
	"./wonder-baby.jpg": 60990,
	"./world-prematurity-day.jpg": 43021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1147;